// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ad8e9d1","239":"ed6fc407","553":"8a234ee9"}[chunkId] + ".chunk.js";
};